module.exports = __webpack_public_path__ + "img/logo.db9c5c7e.png";